<template>
  <div class="content">
    <!-- 详情弹窗 -->
    <el-dialog
      v-model="detailDialogVisible"
      :title="detailDialogTitle"
      width="700px"
      :before-close="handleDetailDialogClose"
      class="detail-dialog"
    >
      <div class="dialog-content">
        <div class="detail-section">
          <div class="detail-item">
            <div class="detail-label">名称：</div>
            <div class="detail-value">{{ detailData.enterpriseName || detailData.name||detailData.enterpriseName }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">简介：</div>
            <div class="detail-value">{{ stripHtml(detailData.companyProfile || detailData.profileContent) || '暂无简介' }}</div>
          </div>
          <div v-if="detailData.leader" class="detail-item">
            <div class="detail-label">法人：</div>
            <div class="detail-value">{{ detailData.leader }}</div>
          </div>
          <div v-if="detailData.orderNum" class="detail-item">
            <div class="detail-label">注册资本：</div>
            <div class="detail-value">{{ detailData.orderNum }}万人民币</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/Container.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-text-wrapper">
          <p class="banner-subtitle"></p>
          <h1 class="banner-title">会员单位</h1>
        </div>
      </div>
    </div>

    <!-- 会员单位区域 -->
    <div class="member-section">
      <!-- 白色内容盒子 -->
      <div class="content-wrapper">
        <!-- 搜索框 -->
        <div class="search-container">
          <div class="search-box">
            <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="7" cy="7" r="5" stroke="#9CA3AF" stroke-width="1.5"/>
              <path d="M11 11L14 14" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <input type="text" placeholder="请输入关键词搜索企业..." class="search-input" />
          </div>
        </div>

        <!-- 标签页 -->
        <div class="tabs-container">
          <div class="tabs-label">会员类型</div>
          <div class="tabs-wrapper">
            <div 
              v-for="(item, index) in tablists" 
              :key="index" 
              :class="['tab-item', { 'tab-active': tabis === item.deptName }]"
              @click="tabchange(item)"
            >
              {{ item.deptName }}
            </div>
          </div>
        </div>

        <!-- 卡片列表 -->
        <div v-loading="loading" element-loading-text="拼命加载中" class="cards-container">
          <div v-if="tableData.length === 0" class="no-data">暂无数据</div>
          
          <div v-for="(item, index) in tableData" :key="index" :class="['member-card', { 'enterprise-card': tabisId === 102 }]" @click="openDetailDialog(item)">
            <!-- 左侧图标 -->
            <div :class="['card-icon', { 'school-icon': tabisId !== 102 }]">
              <img v-if="item.coverUuid" :src="apiPrefix + item.coverUuid" alt="Logo" class="card-logo-img" />
              <img v-else src="../assets/img/sjzy/sjzy.png" alt="Logo" class="card-logo-img" />
            </div>
            
            <!-- 右侧内容 -->
            <div class="card-content">
              <div class="card-header">
                <h3 class="card-title">{{  item.name||item.enterpriseName }}</h3>
              </div>
              
              <div class="card-info">
                <div v-if="tabisId === 102" class="info-item">
                  <span class="info-label">企业简介：</span>
                  <span class="info-value">{{ stripHtml(item.companyProfile) || '暂无简介' }}</span>
                </div>
                <div v-else class="info-item">
                  <span class="info-label">{{ tabisId === 101 ? '高校简介：' : tabisId === 200 ? '院所简介：' : '机构简介：' }}</span>
                  <span class="info-value multi-line">{{ stripHtml(item.profileContent || item.companyProfile) || '暂无简介' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="listnum > 0">
          <div class="pagination-info">共 {{ listnum }} 条数据</div>
          <el-pagination
            class="custom-pagination"
            :page-size="9"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="listnum"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  
  
  
  import { getAction } from '@/api/requests'
  export default {
    name: 'hydwContent',
    components: {
  
    },
    props: {
      idssss: {
      type: String,
      default: '',
    },},
    data(){
      return{
        listnum:0,
        tableData:[],
        tableDatas:[],
        tablists: [],
        tabis: '',
        tabisId: '',
        loading:false,
        apiPrefix: '/prod-api',
        detailDialogVisible: false,
        detailDialogTitle: '',
        detailData: {}
      }
    },
    watch: {
      idssss:{
      handler(val) {
   
        console.log(val);
        this.getzjsjlist()
      }
    },
    },
    mounted(){
      this.getMemberTypes()
      this.injectDetailDialogStyles()
    },
    methods:{
       stripHtml(str = '') {
        return new DOMParser()
          .parseFromString(str, 'text/html')
          .body.textContent || '';
      },
      injectDetailDialogStyles() {
        const style = document.createElement('style')
        style.textContent = `
          .detail-dialog .el-dialog {
            display: flex;
            flex-direction: column;
          }
          .detail-dialog .el-dialog__header {
            background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
            padding: 24px 32px !important;
            border-radius: 16px 16px 0 0 !important;
            margin: 0 !important;
            flex-shrink: 0;
            position: relative;
            z-index: 10;
          }
          .detail-dialog .el-dialog__title {
            color: #FFFFFF !important;
            font-size: 18px !important;
            font-weight: 600 !important;
          }
          .detail-dialog .el-dialog__headerbtn {
            background: rgba(255, 255, 255, 0.2) !important;
            position: absolute;
            top: 24px;
            right: 32px;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 11;
            transition: all 0.3s;
          }
          .detail-dialog .el-dialog__headerbtn:hover {
            background: rgba(255, 255, 255, 0.3) !important;
            transform: scale(1.1);
          }
          .detail-dialog .el-dialog__close {
            color: #FFFFFF !important;
            font-size: 18px !important;
            font-weight: bold !important;
          }
          .detail-dialog .el-dialog__body {
            flex: 1;
            overflow-y: auto;
            padding: 32px;
          }
        `
        document.head.appendChild(style)
      },
       yeshu (x = 5, y = 5) {
                console.log(x, y);
                this.tableDatas = []
                this.tableData.forEach((element, index) => {
                    if (x == 5) {
                        if (index < y && index > y - x || index == y - x) {

                            this.tableDatas.push(element)
                        }
                    } else {
                        if (index < y && index > x || index == y - x) {

                            this.tableDatas.push(element)
                        }
                    }

                });
                console.log(this.listdata);
            },
      getMemberTypes() {
        getAction('/system/dept/listGetByParentId', { parentId: 100 }).then(res => {
          const list = res.data || []
          this.tablists = list.map(item => ({
            deptId: item.deptId,
            deptName: item.deptName
          }))
          if (this.tablists.length > 0) {
            this.tabis = this.tablists[0].deptName
            this.tabisId = this.tablists[0].deptId
            this.getzjsjlist()
          }
        }).catch(() => {})
      },
      getzjsjlist(e=1){
        this.loading = true
        let url = ''
        let data = {
          pageNum: e,
          pageSize: 9
        }

        // deptId: 102=企业, 101=高校, 200=科研院所, 其他用通用接口
        if (this.tabisId === 102) {
          url = '/edu/information/queryMhlist'
          data.parentId = 102
        } else if (this.tabisId === 101) {
          url = '/edu/school/list?classification=0&pageNum=' + e + '&pageSize=9'
        } else if (this.tabisId === 200) {
          url = '/edu/school/list?classification=1&pageNum=' + e + '&pageSize=9'
        } else {
          url = '/edu/information/queryMhlist'
          data.parentId = this.tabisId
        }

        getAction(url, (this.tabisId === 101 || this.tabisId === 200) ? {} : data).then(res => {
          this.listnum = res.total || 0
          this.tableData = res.rows || res.data || []
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.getzjsjlist(val)
      },
      tabchange(item){
        this.tabis = item.deptName
        this.tabisId = item.deptId
        this.getzjsjlist(1)
      },
      openDetailDialog(item) {
        this.detailData = item
        this.detailDialogTitle =  item.enterpriseName ||item.name
        this.detailDialogVisible = true
      },
      handleDetailDialogClose() {
        this.detailDialogVisible = false
        this.detailData = {}
      }
    }
  }
  </script>
  
  <style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text-wrapper {
  text-align: center;
}

.banner-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #51A2FF;
  letter-spacing: 2px;
  margin: 0 0 8px 0;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  position: relative;
  padding-bottom: 20px;
}


/* 会员单位区域 */
.member-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -60px;
  z-index: 10;
  padding-bottom: 60px;
}

/* 白色内容盒子 */
.content-wrapper {
  width: 1500px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 搜索框 */
.search-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 24px;
  width: 420px;
}

.search-icon {
  flex-shrink: 0;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #374151;
}

.search-input::placeholder {
  color: #C4C9D4;
}

/* 标签页 */
.tabs-container {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #E5E7EB;
}

.tabs-label {
  font-size: 14px;
  font-weight: 700;
  color: #374151;
  flex-shrink: 0;
}

.tabs-wrapper {
  display: flex;
  gap: 8px;
}

.tab-item {
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 6px;
  background: #F9FAFB;
  white-space: nowrap;
}

.tab-item:hover {
  color: #3B82F6;
  background: #EFF6FF;
}

.tab-active {
  background: #3B82F6;
  color: #FFFFFF !important;
}

/* 卡片容器 */
.cards-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  min-height: 400px;
}

.no-data {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 0;
  font-size: 16px;
  color: #9CA3AF;
}

/* 会员卡片 */
.member-card {
  width: 413px;
  height: 169px;
  display: flex;
  gap: 16px;
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  transition: all 0.3s;
  cursor: pointer;
  box-sizing: border-box;
  align-items: flex-start;
}

.member-card.enterprise-card {
  width: 413px;
  height: auto;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;
}

.member-card:hover {
  border-color: #3B82F6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
}

/* 卡片图标 */
.card-icon {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  background: #F3F4F6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.card-icon.school-icon {
  height: 120px;
}

.member-card.enterprise-card .card-icon {
  width: calc(100% - 40px);
  height: 180px;
  border-radius: 8px;
}

.card-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 卡片内容 */
.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.member-card.enterprise-card .card-content {
  flex: 1;
  width: 100%;
}

.card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.member-card.enterprise-card .card-header {
  text-align: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-card.enterprise-card .card-title {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.card-tag {
  font-size: 12px;
  padding: 2px 8px;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.member-card.enterprise-card .card-info {
  text-align: center;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #6B7280;
  line-height: 1.5;
}

.member-card.enterprise-card .info-item {
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.info-item svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.info-label {
  flex-shrink: 0;
  color: #9CA3AF;
}

.member-card.enterprise-card .info-label {
  display: none;
}

.info-value {
  flex: 1;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-card.enterprise-card .info-value {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
}

.info-value.multi-line {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #3B82F6 !important;
  color: #FFFFFF !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.disabled)) {
  background-color: #FFFFFF !important;
  color: #6B7280 !important;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:hover) {
  color: #3B82F6 !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next),
:deep(.custom-pagination.el-pagination.is-background .btn-prev) {
  background-color: #FFFFFF;
  color: #6B7280;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:hover),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:hover) {
  color: #3B82F6;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:disabled),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:disabled) {
  background-color: #F9FAFB;
  color: #D1D5DB;
  border-color: #E5E7EB;
}

/* 详情弹窗内容样式 */
.dialog-content {
  width: 100%;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border-left: 3px solid #3B82F6;
}

.detail-label {
  min-width: 80px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  word-break: break-word;
}
  </style>
  
  